import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "../modules/Breadcrumbs";
import "./queries.scss";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DropSelect from "../modules/AutoComplete";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import BtnSet from "./BtnSet";
import StaticItem from "../modules/StaticItem";
import CustomizedAccordions from "../modules/Accordian";
import "./queries.scss";
import Avatars from "../modules/Avatar";
import QueryContent from "./QueryContent";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addQueries, addQueryDocs, setCaseId } from "./redux/actions";
import Button from "../modules/Button";
import { addDocInfo } from "../LoginPage/redux/actions";
import { useNavigate } from "react-router-dom";

function ViewQueries() {
  const navigate = useNavigate();

  const [query, setQuery] = useState({ cat: "", details: "", doc: [] });
  const [btn, setBtn] = useState(true);
  const dispatch = useDispatch();
  console.log("query", query);
  const queryDocs = useSelector((state) => state.queryDocs);
  const [qDocs, setQDocs] = useState([]);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const queries = useSelector((state) => state.queries.queries);

  const showQuestion = (item) => {
    return (
      <div className="question">
        <div className="question-left">
          <div className="question-top md-desc">
            #{item.caseNumber} - {item.createdAt}
          </div>
          <div className="question-btm set-title">{item.caseCategory}</div>
        </div>
        <div className="question-right">
          <Button
            // disabled={props.isBtn}
            type={"contained"}
            value={"Edit"}
            onClickHandler={() => updateField(item?.id)}
          />
          <div className="question-status md-desc">{item.caseStatus}</div>
        </div>
      </div>
    );
  };
  const updateField = (id) => {
    if (id) {
      dispatch(setCaseId(id));
    }
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/update-queries");
    navigate("/application/help/update-queries");
  };
  const raiseField = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/raise-queries");
    navigate("/application/help/raise-queries");
  };
  async function callQuery() {
    try {
      const result = await api.getQuery(tokenData?.token, tokenData?.appId);
      // setData(result);
      if (result.statusCode == 200) {
        dispatch(addQueries(result.data));
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
  async function callDocs() {
    console.log("in doc function", tokenData, queries);
    try {
      const docs2 = await api.getDocuments(
        "cases",
        // queries?.caseId,
        tokenData.appId,
        tokenData?.token
      );
      console.log("in docs api", docs2);
      setQDocs(docs2);
      dispatch(addQueryDocs(docs2));

      // setData(result);
      // dispatch(addQueries(result.data));
    } catch (error) {
      console.error("Error:", error);
    }
  }
  useEffect(() => {
    let btn1 = true;
    for (let i in query) {
      if (query[i]?.length === 0) {
        btn1 = false;
      }
    }
    setBtn(btn1);
  }, [query]);

  useEffect(() => {
    callQuery();
    callDocs();
  }, []);
  console.log("token in ", tokenData, queryDocs, qDocs);
  return (
    <div className=" view-query">
      <div className="bc">
        <BreadCrumbComponent list={["Help", "View Queries"]} />
      </div>
      <div className="raise-heading">
        <div className="form-title">Your Queries</div>
        <div onClick={raiseField} className="left-btn upload-top-text">
          Raise Query
          <NavigateNextIcon fontSize="small" />
        </div>
      </div>
      <div className="cred-fields">
        {/* {[
          {
            applicationId: 24,
            caseCategory: "Page",
            caseDetails: "New issue",
            caseDocument: [],
            caseNumber: null,
            caseStatus: "Assigned",
            id: 6,
          },
        ].map((item, index) => { */}
        {Object.values(queries)
          ?.reverse()
          .map((item, index) => {
            return (
              <CustomizedAccordions
                // key={index}
                question={showQuestion(item)}
              >
                <QueryContent item={item} />
              </CustomizedAccordions>
            );
          })}
      </div>
      {/* {queryDocs?.length > 0 && (
        <div className="doc-list doc-col">
          {querydocs?.map((item, index) => {
            // if (querydocs?.data[item.id]) {
            return (
              <div className="doc-item" key={index}>
                <StaticItem
                  type={"doc"}
                  docUrl={item?.documentUrl}
                  value={item?.name}
                  size={item?.size / 1024}
                  title={""}
                />
              </div>
            );
            // }
          })}
        </div>
      )} */}
      {/* <BtnSet isBtn={!btn} type={"query"} btnText={"Submit"} /> */}
    </div>
  );
}

export default ViewQueries;
